"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var asyncScriptLoader = function (src, bundleListKey) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.async = true;
        script.src = src;
        if (!window[bundleListKey]) {
            window[bundleListKey] = [];
        }
        var existingPolyfill = window[bundleListKey].find(function (loadedScript) {
            return loadedScript.script.isEqualNode(script);
        });
        if (existingPolyfill) {
            if (existingPolyfill.hasLoaded) {
                resolve();
            }
            existingPolyfill.script.addEventListener('load', function () { return resolve(); });
            return;
        }
        var scriptEntry = {
            script: script,
            hasLoaded: false,
        };
        window[bundleListKey].push(scriptEntry);
        script.addEventListener('load', function () {
            scriptEntry.hasLoaded = true;
            resolve();
        });
        script.addEventListener('error', function () { return reject(new Error('Polyfill failed to load')); });
        document.head.appendChild(script);
    });
};
exports.default = asyncScriptLoader;
